/**
 * Replace all instances of single quote in a string with an escaped sequence.
 * Used for FQL and transformers.
 * @param value string
 * @returns string
 */
export function escapeSingleQuotes(value: string): string {
    return value.replace(/'/g, '\\\'');
}
